import React from 'react';
import { slotKey, slotLabel } from 'utils/deliverySlots';

/**
 * One dropdown of "day · time" delivery slots, shared by checkout and the subscription screens.
 * A slot with a `deliveryDate` shows that date; a recurring one shows the weekday.
 * @param {Array<{day, time, fee, deliveryDate?}>} slots
 * @param {string} value slotKey(day, time) of the chosen slot, or '' with a placeholder
 * @param {(slot: object|null) => void} onChange receives the chosen slot object
 */
export default function DeliverySlotSelect({ slots, value, onChange, showFee = false, placeholder, ...rest }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(slots.find((s) => slotKey(s.day, s.time) === e.target.value) || null)}
      {...rest}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {slots.map((slot) => (
        <option key={slotKey(slot.day, slot.time)} value={slotKey(slot.day, slot.time)}>
          {slotLabel(slot)}{showFee && slot.fee > 0 ? ` · $${Number(slot.fee).toFixed(2)} delivery` : ''}
        </option>
      ))}
    </select>
  );
}
